import object from '@mailobj-browser/front/js/utils/object.js'
import rect from './rect.js'

export default (
  target
) => {
  const { ownerDocument } = target
  const { documentElement } = ownerDocument
  const { clientHeight, clientWidth } = documentElement
  const { height, width, x, y } = rect(target)
  
  return object(null, {
    clientHeight,
    clientWidth,
    height,
    width,
    x,
    y
  })
}
